import PropTypes from 'prop-types';

const SERIES_EVENT_VENUE_SHAPE = PropTypes.shape({
    address: PropTypes.shape({
        localizedAreaDisplay: PropTypes.string,
    }),
});

const SERIES_EVENT_TICKET_AVAILABILITY_SHAPE = PropTypes.shape({
    hasAvailableTickets: PropTypes.bool.isRequired,
    minimumTicketPrice: PropTypes.shape({
        value: PropTypes.number.isRequired,
        currency: PropTypes.string.isRequired,
    }),
});

const SERIES_EVENT_SALES_STATUS = PropTypes.shape({
    salesStatus: PropTypes.string.isRequired,
});

export const SERIES_EVENT_PROP_TYPES = {
    id: PropTypes.string.isRequired,

    isRegEvent: PropTypes.bool,

    name: PropTypes.object.isRequired,

    start: PropTypes.object.isRequired,

    end: PropTypes.object.isRequired,

    ticketAvailability: SERIES_EVENT_TICKET_AVAILABILITY_SHAPE,

    eventSalesStatus: SERIES_EVENT_SALES_STATUS,

    hideEndDate: PropTypes.bool.isRequired,

    locale: PropTypes.string.isRequired,

    venue: SERIES_EVENT_VENUE_SHAPE,
};

export const SERIES_EVENT_PROP_TYPES_SHAPE = PropTypes.shape(
    SERIES_EVENT_PROP_TYPES,
);
